import get from 'lodash/get'

class PlayerControl {
  constructor(data) {
    this.autoTrigger = get(data, 'autoTrigger');
    this.action = data.action;
    this.additionalAction = data.additionalAction;
    this.offset = data.offset;
    this.timer = data.timer;
  }
}

class OpenLink {
  constructor(data) {
    this.autoTrigger = get(data, 'autoTrigger');
    this.action = 'openLink';
    this.link = data.link;
    this.target = data.target;
  }
}

class OpenMailto {
  constructor(data) {
    this.autoTrigger = get(data, 'autoTrigger');
    this.action = 'openMailto';
    this.hrefmailto = data.hrefmailto;
    this.target = data.target;
  }
}

class OpenVideo {
  constructor(data) {
    this.autoTrigger = get(data, 'autoTrigger');
    this.action = 'openVideo';
    this.data = {
      videoId: data.videoId,
      autoplay: data.autoplay,
      mute: data.mute,
      startAt: data.startAt
    }
  }
}

export { PlayerControl, OpenLink, OpenVideo, OpenMailto }
